import type { InfoHintDetail } from '@cou/admin-ui';
import { formatDateTime } from './format-date';
import type { CuratedEvent, CuratedMarket } from './catalogue-client';

/**
 * The rows behind a Slate tab event header's ⓘ hint.
 *
 * Competition is omitted rather than dashed when absent. The header beside it renders a display
 * fallback of "MLB" (`formatEventMeta`), and a finalised Contest's frozen slate carries no
 * competition at all — so a "—" row would sit next to a visible "MLB" and read as a contradiction.
 * A hint that states nothing beats one that argues with the screen.
 */
export function slateEventDetails(event: CuratedEvent): InfoHintDetail[] {
  const rows: InfoHintDetail[] = [
    { label: 'Event ID', value: event.id, copyable: true },
    { label: 'Starts', value: formatDateTime(event.startTime) },
  ];
  if (event.competition !== null) rows.push({ label: 'Competition', value: event.competition });
  return rows;
}

/**
 * The rows behind a Slate tab market subject's ⓘ hint. The Line is rendered to one decimal
 * because every v1 Line is a half-point — trailing precision would imply a movement that
 * cannot happen (a line move is a different Market, with new ids).
 */
export function slateMarketDetails(market: CuratedMarket): InfoHintDetail[] {
  return [
    { label: 'Market ID', value: market.id, copyable: true },
    { label: 'Type', value: market.marketType },
    { label: 'Line', value: market.line.toFixed(1) },
    { label: 'Event ID', value: market.eventId, copyable: true },
  ];
}
